export default "__VITE_ASSET__Dfj9zZVD__"